'use client';
import { Simple as Tooltip } from '@/ui/Tooltip';
import Button from '@/ui/Button';
import { IRepository } from '@/types';
import * as Icon from '@/ui/Icon';
import useOxenSession from '@/hooks/useOxenSession';

const ForkRepositoryButton = ({ repository, disabled }: { repository: IRepository; disabled: boolean }) => {
  return (
    <Button.Basic
      href={`/${repository.namespace}/${repository.name}/fork`}
      small
      className="success"
      disabled={disabled}
    >
      <Icon.Fork style={{ marginRight: 5 }} /> Fork this repository to run your own evaluations
    </Button.Basic>
  );
};

const NoAccessTooltipContent = () => (
  <div>
    You do not have access to create evaluations in this repository.
    <br />
    To gain access, contact the repository owner to request edit or admin access.
  </div>
);

const CreateEvaluationButton: React.FC<{
  repository: IRepository;
  sectionNavigationPath: string;
  hasEvaluations: boolean;
}> = ({ repository, sectionNavigationPath, hasEvaluations }) => {
  const { authorization } = useOxenSession();
  const repoAuth = authorization.forRepository(repository);

  if (!repoAuth.canCreateEvaluations()) {
    return <ForkRepositoryButton repository={repository} disabled={authorization.requiresVerification()} />;
  }

  return (
    <Tooltip content={<NoAccessTooltipContent />} dark>
      <Button.Black small href={`/${repository.namespace}/${repository.name}/${sectionNavigationPath}/new`}>
        Create {!hasEvaluations && 'your first '}Evaluation
      </Button.Black>
    </Tooltip>
  );
};

export default CreateEvaluationButton;
